import { memo } from 'react';
import { TournamentRanking } from '@zmedia/bm-soccer-ui/modules/tournament/views/ranking';

export function TeamStanding(props: any) {
    const { primaryTournament, id } = props;
    return (
        <TournamentRanking
            {...props}
            {...primaryTournament}
            teamIdSelect={id}
        ></TournamentRanking>
    );
}

export default memo(TeamStanding);
